/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'home': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zm-.438 4.171L4.109 9.415c-.221.202-.084.585.216.585H5v4.328c0 .37.293.672.652.672h2.691a.665.665 0 00.653-.672v-3.323h2.007v3.323c0 .37.294.672.652.672h2.69a.665.665 0 00.652-.672V10h.674c.3 0 .444-.383.216-.585l-5.452-5.244a.642.642 0 00-.874 0z" _fill="#004CD0" fill-rule="evenodd"/>'
  }
})
